import api from '../../utils/api';
import store from '../index';
import authStore from './auth';

const actions = {
	async renMoneyFetchApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response && response.data && response.data.token) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async renMoneyPostApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.post(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response?.data?.token) {
					commit('updateToken', response?.data?.token);
				}
				if (response && response.data && response.data.token) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				if (response.message.includes('Existing')) {
					await commit('setNewUser', true);
				}
				if (response.next_step.name === 'LOAN_STATUS') {
					commit('setIsLoading', false);
					commit('setIframeResponseOnSuccess', {
						status: true,
						type: 'SUCCESS',
						data: {
							status: 'successful',
							data: {
								reference: response.data.reference,
								redirect_url: authStore.state.payload.redirect_url
									? authStore.state.payload.redirect_url
									: false
							}
						}
					});
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	actions
};

